<app-complex-modal-template
    class="overflow-visible"
    [canConfirm]="!!formGroup()?.valid"
    [title]="'addRole' | transloco"
    (onClickEvent)="closeModal($event)">
    <form class="flex flex-col gap-5 pb-11">
        <section class="flex flex-row gap-7">
            <app-input-text
                class="grow"
                [errors]="
                    formGroup()!.controls.name!.value!.length > FormService.VARCHAR_SMALL_LENGTH
                        ? ['characterLimitExceeded' | transloco: { value: 50 }]
                        : []
                "
                [inputFormControl]="formGroup()!.controls.name"
                [label]="'roleName' | transloco"
                [placeholder]="'enterRoleName' | transloco" />

            <app-input-number
                [inputFormControl]="formGroup()!.controls.maxAssignment"
                [label]="'maxAssignments' | transloco"
                [min]="0"
                [placeholder]="'unlimited' | transloco" />
        </section>

        <div
            class="flex flex-row gap-7"
            [class.opacity-50]="hasAllPermissions()"
            [class.pointer-events-none]="hasAllPermissions()">
            <section class="flex flex-col grow gap-2.5 max-w-56">
                <div class="flex flex-col gap-0.5 grow">
                    <label class="font-normal text-base">{{ 'manage' | transloco }}</label>

                    <app-select
                        class="w-full"
                        data-testid="manage-pages-select"
                        [isMultiSelect]="true"
                        [options]="optionsManage()"
                        [placeholder]="'selectPage' | transloco: { COUNT: 0 }"
                        [(selectedOptions)]="selectedOptionManage"
                        (optionSelected)="onSelectOptionChange()" />
                </div>
                <p class="font-normal text-[0.625rem] text-custom-dark-grey">
                    {{ 'permission.manageSelectInfo' | transloco }}
                </p>
            </section>

            <section class="flex flex-col grow gap-2.5 max-w-56">
                <div class="flex flex-col gap-0.5 grow">
                    <label class="font-normal text-base">{{ 'toAccess' | transloco }}</label>

                    <app-select
                        class="w-full"
                        data-testid="access-pages-select"
                        [isMultiSelect]="true"
                        [options]="optionsAccess()"
                        [placeholder]="'selectPage' | transloco: { COUNT: 0 }"
                        [(selectedOptions)]="selectedOptionAccess"
                        (optionSelected)="onSelectOptionChange()" />
                </div>
                <p class="font-normal text-[0.625rem] text-custom-dark-grey">
                    {{ 'permission.accessSelectInfo' | transloco }}
                </p>
            </section>
        </div>

        <div
            class="flex flex-row gap-2 cursor-pointer"
            (click)="changeSelection()">
            <app-checkbox [checkboxState]="hasAllPermissions() ? CheckboxState.CHECKED : CheckboxState.UNCHECKED" />
            {{ 'allPermissions' | transloco }}
        </div>
    </form>
</app-complex-modal-template>
